/* eslint-disable */
const getters = {
  getGiftActions(state) {
    return state.data;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
